import { AppState, Platform } from 'react-native'

let foreground = true
let listenersStarted = false
const subscribers = new Set<(isForeground: boolean) => void>()

function readForeground(): boolean {
    if (Platform.OS === 'web' && typeof document !== 'undefined') {
        return document.visibilityState !== 'hidden'
    }
    return AppState.currentState === 'active'
}

function setForeground(next: boolean) {
    if (foreground === next) {
        return
    }
    foreground = next
    subscribers.forEach(cb => cb(next))
}

/** Start listening once; safe to call from interceptor or hooks. */
export function ensureAppForegroundTracking(): void {
    if (listenersStarted) {
        return
    }
    listenersStarted = true
    foreground = readForeground()

    if (Platform.OS === 'web' && typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', () => {
            setForeground(document.visibilityState !== 'hidden')
        })
    }

    AppState.addEventListener('change', state => {
        if (Platform.OS === 'web' && typeof document !== 'undefined') {
            setForeground(document.visibilityState !== 'hidden')
            return
        }
        setForeground(state === 'active')
    })
}

export function isAppForeground(): boolean {
    ensureAppForegroundTracking()
    return foreground
}

export function subscribeAppForeground(cb: (isForeground: boolean) => void): () => void {
    ensureAppForegroundTracking()
    subscribers.add(cb)
    return () => {
        subscribers.delete(cb)
    }
}
